/**
 * @description Timeout for provided function
 * @param fn function to be called after specified time
 * @param time time before call callback
 * @returns Timeout disposable
 */
export function timeout(fn, time = 0) {
  let timer;

  timer = setTimeout(() => {
    if (fn) {
      fn();
    }

    timer = undefined;
    fn = undefined;
  }, time);

  return () => {
    if (timer) {
      clearTimeout(timer);

      timer = undefined;
      fn = undefined;
    }
  };
}
